import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '../modal.module.scss';

const LawnMapModal = ({ onClose, isOpen, src }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.lawnMapModal}>
      <img
        style={{ maxHeight: '95vh', objectFit: 'contain' }}
        src={src}
        alt=""
      />
    </Modal>
  );
};

export default LawnMapModal;
